// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"PrivacyPolicy_PrivacyPolicy__r-1sV","text":"PrivacyPolicy_text__JNWUG"};